import { IColumn } from '@repo/ui';
import { useLegends } from 'presentation/app/hooks/useLegends';

export const makeActivitiesValidatedByProfessionalsColumns = (): IColumn[] => {
  const { getLegends } = useLegends();

  return [
    {
      title: getLegends('ESTUDANTE', false),
      dataKey: 'student',
      width: 300,
    },
    {
      title: 'Data',
      dataKey: 'date',
    },
    {
      title: 'Tarefa',
      dataKey: 'task',
      width: 200,
    },

    {
      title: getLegends('LOCAL_ESTAGIO', false),
      dataKey: 'place',
      width: 240,
    },
    {
      title: 'Situação',
      dataKey: 'situation',
    },
    {
      title: 'Validada em',
      dataKey: 'validatedAt',
    },
  ];
};
